import {
  Box,
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { TPModalProps } from './TPModal.proptype';
import { CenteredProgress } from '../../components';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: theme.shape.borderRadius,
    padding: 0
  },
  headerWrapper: {
    padding: theme.spacing(1.5, 2.5),
    '& > *': {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  },
  modalTitle: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1
  },
  actionsWrapper: {
    padding: theme.spacing(2, 2.5)
  }
}));

const TPModal = ({
  children,
  container,
  containerStyle,
  headerContent,
  actions,
  title,
  isOpen,
  maxWidth,
  closeIcon: Icon,
  centeredProgressSize,
  onClose,
  footerComponent
}: TPModalProps) => {
  const classes = useStyles();

  const handleCloseProps = (event?: Record<string, unknown>, reason?: string) => {
    onClose(event, reason);
  };

  const handleCloseIcon = () => {
    onClose();
  };

  const hasContainer = Boolean(container);

  return (
    <Dialog
      fullWidth
      disableEnforceFocus
      open={isOpen}
      maxWidth={maxWidth ?? 'lg'}
      scroll="paper"
      classes={{ paper: classes.paper }}
      container={container}
      style={hasContainer ? { position: 'absolute' } : {}}
      BackdropProps={hasContainer ? { style: { position: 'absolute' } } : {}}
      disablePortal={hasContainer}
      onClose={handleCloseProps}
    >
      <DialogTitle classes={{ root: classes.headerWrapper }}>
        <Box component="span" className={classes.modalTitle}>
          {title}
        </Box>
        {headerContent}
        <IconButton onClick={handleCloseIcon}>{Icon ? <Icon /> : <CloseIcon />}</IconButton>
      </DialogTitle>
      <DialogContent dividers className={containerStyle}>
        {children}
      </DialogContent>
      {actions && (
        <DialogActions className={classes.actionsWrapper}>
          {footerComponent ?? null}
          {actions.map(({ name, id, handler, ...otherProps }) =>
            name === '' ? (
              <Button key={name} id={id}>
                <CenteredProgress size={centeredProgressSize} />
              </Button>
            ) : (
              <Button key={name} id={id} onClick={handler} {...otherProps}>
                {name}
              </Button>
            )
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default TPModal;
